<template>
  <div class="po-processing-page">
    <div class="page-header">
      <h2>Purchase Order Processing</h2>
      <div class="actions">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search by supplier or PO number..."
          class="search-box"
        />
        <button class="btn btn-green" @click="fetchPOs">Fetch</button>
        <button class="btn btn-blue" @click="printPOs">Print</button>
      </div>
    </div>

    <div class="pos-table">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>PO Number</th>
            <th>Date</th>
            <th>Supplier</th>
            <th>Amount (₦)</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(po, index) in filteredPOs" :key="po.id">
            <td>{{ index + 1 }}</td>
            <td>{{ po.po_number }}</td>
            <td>{{ formatDate(po.date) }}</td>
            <td>{{ po.supplier }}</td>
            <td>{{ formatAmount(po.amount) }}</td>
            <td>
              <span :class="['status-badge', po.status.toLowerCase()]">
                {{ po.status }}
              </span>
            </td>
            <td>
              <button class="btn btn-green btn-sm" @click="approvePO(po.id)">
                Approve
              </button>
              <button class="btn btn-red btn-sm" @click="rejectPO(po.id)">
                Reject
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!filteredPOs.length" class="no-results">
        No purchase orders found.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PoProcessingPage",
  data() {
    return {
      purchaseOrders: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredPOs() {
      if (!this.searchQuery.trim()) return this.purchaseOrders;
      const query = this.searchQuery.toLowerCase();
      return this.purchaseOrders.filter(
        (po) =>
          po.supplier.toLowerCase().includes(query) ||
          po.po_number.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    async fetchPOs() {
      // Replace this with your actual API call
      const res = {
        data: {
          status: "success",
          data: [
            {
              id: 1,
              po_number: "PO-0001",
              date: "2025-06-05",
              supplier: "Global Supplies Ltd",
              amount: 350000,
              status: "Pending",
            },
            {
              id: 2,
              po_number: "PO-0002",
              date: "2025-06-06",
              supplier: "Westline Pharma",
              amount: 125000,
              status: "Pending",
            },
            {
              id: 3,
              po_number: "PO-0003",
              date: "2025-06-08",
              supplier: "MedTech Equipments",
              amount: 245000,
              status: "Pending",
            },
          ],
        },
      };

      this.purchaseOrders = res.data.data;
    },
    approvePO(id) {
      const po = this.purchaseOrders.find((p) => p.id === id);
      if (po) po.status = "Approved";
    },
    rejectPO(id) {
      const po = this.purchaseOrders.find((p) => p.id === id);
      if (po) po.status = "Rejected";
    },
    printPOs() {
      window.print();
    },
    formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },
    formatAmount(amount) {
      return amount.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
  },
  mounted() {
    this.fetchPOs();
  },
};
</script>

<style scoped>
.po-processing-page {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.search-box {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.btn {
  padding: 8px 16px;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.btn-green {
  background-color: #28a745;
}

.btn-green:hover {
  background-color: #218838;
}

.btn-blue {
  background-color: #0069d9;
}

.btn-blue:hover {
  background-color: #0053b3;
}

.btn-red {
  background-color: #dc3545;
}

.btn-red:hover {
  background-color: #c82333;
}

.btn-sm {
  padding: 6px 10px;
  font-size: 0.85rem;
  margin-right: 4px;
}

.pos-table table {
  width: 100%;
  border-collapse: collapse;
}

.pos-table th,
.pos-table td {
  border: 1px solid #ddd;
  padding: 0.75rem;
  text-align: left;
}

.pos-table th {
  background-color: #f8f9fa;
}

.no-results {
  padding: 1rem;
  text-align: center;
  color: #888;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
}

.status-badge.pending {
  background-color: #ffc107;
}

.status-badge.approved {
  background-color: #28a745;
}

.status-badge.rejected {
  background-color: #dc3545;
}
</style>
